import {
  Pipe,
  PipeTransform,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { Timestamp } from '@angular/fire/firestore';

@Pipe({
    name: 'elapsedTime',
    pure: false,
    standalone: false
})
export class ElapsedTimePipe implements PipeTransform, OnDestroy {
  private subscription!: Subscription;
  private formattedTime: string | null = null;

  constructor(private cdr: ChangeDetectorRef) {}

  transform(startTime: Timestamp | null): string | null {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    if (startTime === null) {
      return null;
    }

    this.updateTime(startTime);

    this.subscription = interval(1000).subscribe(() => {
      this.updateTime(startTime);
      this.cdr.markForCheck();
    });

    return this.formattedTime;
  }

  private updateTime(startTime: Timestamp): void {
    const start = startTime.toDate().getTime();
    const now = new Date().getTime();
    const totalSeconds = Math.floor((now - start) / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    this.formattedTime = `${hours}h ${minutes}m ${seconds}s`;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
